module.exports = "/images/engagement.png?69cc02a395b2b8971f3d5abecaac7aa7";